import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Wyoming = () => {
  return (
    <StatePropertyTaxPage
      stateName="Wyoming"
      processDescription="Property owners may appeal their assessment by filing with the county board of equalization within 30 days of receiving notice. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in May following annual assessments."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Wyoming assesses property as of January 1 each year. This assessment date captures the property's fair market value at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners have 30 days from receiving notice to file appeals with the county board of equalization. This typically results in a June deadline."
    />
  );
};

export default Wyoming;